import { Result, getReadableErrorMessage } from "@bridgesplit/utils";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";

type MutationResult<T> =
    | {
          data: T;
      }
    | {
          error: FetchBaseQueryError | SerializedError;
      };
export async function mutationIntoResult<Body, Response>(
    promise: (body: Body) => Promise<MutationResult<Response>>,
    body: Body,
    taskDescription: string,
    options?: { useCustomErrorMessage?: boolean }
): Promise<Result<Response>> {
    const res = await promise(body);
    if ("error" in res)
        return Result.errWithDebug(
            options?.useCustomErrorMessage ? taskDescription : getReadableErrorMessage(taskDescription),
            res
        );
    return Result.ok(res.data);
}

export async function mutationIntoRawResult<Body, Response>(
    promise: (body: Body) => Promise<MutationResult<Response>>,
    body: Body
): Promise<Result<Response>> {
    const res = await promise(body);

    if ("error" in res) return Result.err(res);
    return Result.ok(res.data);
}
